export default __webpack_public_path__ + "static/media/flag_en.c92a8361.svg";